"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fallback = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.Fallback = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  background: ", ";\n  font-weight: 600;\n  text-transform: uppercase;\n  text-align: center;\n  height: 100%;\n  width: 100%;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  background: ", ";\n  font-weight: 600;\n  text-transform: uppercase;\n  text-align: center;\n  height: 100%;\n  width: 100%;\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.DEFAULT', theme);
});
var templateObject_1;